import * as React from "react";

import TimelapseOutlinedIcon from "@mui/icons-material/TimelapseOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

const iconStyle = { width: "20px", height: "20px" };
export const OrderShipmentStatusEnumIcons = [
  {
    id: "in_progress",
    name: "In Progress",
    color: "primary",
    icon: <TimelapseOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "in_transit",
    name: "In Transit",
    color: "warning",
    icon: <LocalShippingOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "delivered",
    name: "Delivered",
    color: "success",
    icon: <CheckOutlinedIcon sx={iconStyle} />,
  },
  {
    id: "canceled",
    name: "Canceled",
    color: "error",
    icon: <CancelOutlinedIcon sx={iconStyle} />,
  }
];
